// @flow

import _ from 'lodash';

import { SIGNUP_PRE_INTENT_EVENT } from '@zapier/toolbox-tracking';

import log from 'app/common/log';
import trackingFunctions, { trackEvent } from 'app/track/trackingFunctions';

import { type HomepageV2EventShape } from 'app/homepagev2/scripts/Container';

type PopupSurveyEvent = 'shown' | 'completed' | 'dismissed';

const CLIENT_SIDE_PAGE_VIEW_EVENT = 'clientSidePageView';

const Data = {
  recordUserId: (userId: string) => {
    return trackEvent(CLIENT_SIDE_PAGE_VIEW_EVENT, {
      userId,
      eventCategory: 'CD',
      eventAction: 'RecordedUserId',
      eventLabel: userId,
    });
  },
  gaPageTrack: (path: string, userId: string) => {
    const metaData = {
      pagePath: path,
      pageTitle: _.get(document, ['title']),
      userId,
    };

    if (path.indexOf('/admin/') !== -1) {
      log('tracking for admin pages is disabled.');
      return;
    }

    trackEvent('clientSidePageView', metaData);
  },
  recordUserPopupSurvey: (response?: string, event: PopupSurveyEvent) => {
    trackEvent(`popup-survey:${event}`, {
      ...(response ? { response } : {}),
      path: _.get(document, ['location', 'pathname']),
    });
  },
  recordHomepageV2Events: (metaData: HomepageV2EventShape) => {
    trackEvent(SIGNUP_PRE_INTENT_EVENT, metaData);
  },
  ...trackingFunctions,
};

export default Data;
